import React from 'react'
import { Box, Typography, Avatar, List, ListItem, ListItemAvatar, ListItemText } from '@mui/material'
import { motion, AnimatePresence } from 'framer-motion'
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents'

const rankColors = ['#FFD700', '#C0C0C0', '#CD7F32']

export default function Leaderboard({ entries = [], compact = false, highlightId }) {
  return (
    <List dense={compact}>
      <AnimatePresence>
        {entries.map((entry, i) => (
          <motion.div
            key={entry.participantId}
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0 }}
            transition={{ delay: i * 0.05 }}
          >
            <ListItem
              sx={{
                bgcolor: entry.participantId === highlightId ? 'action.selected' : 'transparent',
                borderRadius: 1,
                mb: 0.5
              }}
            >
              <ListItemAvatar>
                {entry.photoUrl ? (
                  <Avatar src={entry.photoUrl} />
                ) : (
                  <Avatar sx={{ bgcolor: rankColors[i] || 'primary.main' }}>
                    {i < 3 ? <EmojiEventsIcon /> : entry.rank}
                  </Avatar>
                )}
              </ListItemAvatar>
              <ListItemText
                primary={entry.nickname}
                secondary={compact ? undefined : `${entry.score} pts`}
              />
              <Typography variant={compact ? 'body2' : 'h6'} fontWeight="bold" color="primary">
                {entry.score}
              </Typography>
            </ListItem>
          </motion.div>
        ))}
      </AnimatePresence>
    </List>
  )
}
